export enum $advancedSetupStep {
  scope = 0,
  schedule = 1,
  scanSettings = 2,
  alerts = 3,
  review = 4,
}
